var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-alert',{attrs:{"type":"warning","value":true}},[_vm._v(" "+_vm._s(_vm.$route.path)+" 404 Not Found ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }